import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'

const REASON_LENGTH = 200
const FIELD_LENGTH = 100
const NUMBER_LENGTH = 50

export const toFormInventoryShema = Joi.object({
  documentNumber: Joi.string()
    .max(NUMBER_LENGTH)
    .pattern(new RegExp('^[0-9]*$'))
    .required('')
    .error(errorsResolver({
      max: `Номер документа должен быть до ${NUMBER_LENGTH} символов`,
      required: `Номер документа обязательное поле`,
      pattern: 'Номер документа должен быть числом',
    })),
  transferDate: Joi.date()
    .required('')
    .iso()
    .min(Joi.ref('permissibleDate'))
    .error(errorsResolver({
      required: `Дата обязательное поле`,
      dateFormat: `Некорректная дата`,
      dateMin: `Некорректная дата`,
    })),
  permissibleDate: Joi.date(),
  reason: Joi.string()
    .max(REASON_LENGTH)
    .allow('')
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-.,№ ]*$'))
    .error(errorsResolver({
      max: `Основание должно быть до ${REASON_LENGTH} символов`,
      pattern: `Основание содержит некорректные символы`
    }))
})

export const toFormWithdrawalShema = Joi.object({
  documentNumber: Joi.string()
    .max(NUMBER_LENGTH)
    .pattern(new RegExp('^[0-9]*$'))
    .required('')
    .error(errorsResolver({
      max: `Номер документа должен быть до ${NUMBER_LENGTH} символов`,
      required: `Номер документа обязательное поле`,
      pattern: 'Номер документа должен быть числом',
    })),
  transferDate: Joi.date()
    .required('')
    .iso()
    .error(errorsResolver({
      required: `Дата обязательное поле`,
      dateFormat: `Некорректная дата`
    })),
  reason: Joi.string()
    .max(REASON_LENGTH)
    .allow('')
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\\\(*/,-.№) ]*$'))
    .error(errorsResolver({
      max: `Основание должно быть до ${REASON_LENGTH} символов`,
      pattern: `Основание содержит некорректные символы`
    })),
  withdrawalName: Joi.string()
    .max(FIELD_LENGTH)
    .allow('')
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\- ]*$'))
    .error(errorsResolver({
      max: `Изымающее лицо должно быть до ${FIELD_LENGTH} символов`,
      pattern: `Изымающее лицо содержит некорректные символы`
    })),
  withdrawalDocuments: Joi.string()
    .max(FIELD_LENGTH)
    .allow('')
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-,.№ ]*$'))
    .error(errorsResolver({
      max: `Документы должны быть до ${FIELD_LENGTH} символов`,
      pattern: `Документы содержат некорректные символы`
    }))
})
